import React, {useEffect, useState} from "react";
import axios from "axios";
import {Link} from 'react-router-dom';
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import {baseUrl} from '../Univ.js'
function Minview(props) {
    const [selectedDate, setSelectedDate] = useState(new Date(new Date().getTime() - new Date().getTimezoneOffset() * 60000));
    const [minData, setminData] = useState([]);
    useEffect(() => {
        fetchData();
        const intervalId = setInterval(fetchData, 12000); // Fetch data every 5 seconds
        return () => clearInterval(intervalId); // Cl
    }, [selectedDate]);
    function fetchData() {
        const formattedDate = selectedDate.toISOString().substring(0, 10);
        axios.get(baseUrl + 'min-entry-view/' + formattedDate + '/')
            .then(response => {
                setminData(response.data);
            })
            .catch(error => {
                console.log(error);
            });
    }
    const handleDateChange = (date) => {
        const localDate = new Date(date.getTime() - date.getTimezoneOffset() * 60000);
        setSelectedDate(localDate);
    };
    return (
        <section className="container mt-4">
            <div className="row">
                <div className="col-md-6">
                    <div className="form-group">
                        <label className="col-sm-3 col-lg-2 control-label">Select Date</label>
                        <div className="col-sm-9 col-lg-10 controls">
                            <DatePicker selected={selectedDate} onChange={handleDateChange} dateFormat="dd/MM/yyyy"/>
                        </div>
                    </div>
                </div>
            </div>

            <table className="erp-table-modern">
                <thead>
                <tr style={{backgroundColor: '#1bc5ce', color: 'white'}}>
                    <th align="left">S.No</th>
                    <th align="left">Patient ID</th>
                    <th align="left">Patient</th>
                    <th align="left">Particulars</th>
                    <th align="left">Addedby</th>
                    <th align="left">Request On</th>
                    <th align="left">Action</th>
                </tr>
                </thead>
                {minData.map((row, index) =>
                    <tbody>
                    {row.min_test.split(',').map((test, subIndex) => (
                        <tr key={`${index}-${subIndex}`}>
                            <td style={{border: "1px solid", borderColor: "#2194d9"}}>{index + subIndex + 1}</td>
                            <td style={{border: "1px solid", borderColor: "#2194d9"}}>{row.pat.pat_id}</td>
                            <td style={{border: "1px solid", borderColor: "#2194d9"}}>{row.pat.patient}</td>
                            <td style={{border: "1px solid", borderColor: "#2194d9"}}>{test.trim()}</td>
                            <td style={{border: "1px solid", borderColor: "#2194d9"}}>{test.trim()}</td>
                            <td style={{border: "1px solid", borderColor: "#2194d9"}}>{row.addedby}</td>
                            <td style={{border: "1px solid", borderColor: "#2194d9"}}>{row.add_date}
                                <br></br>{row.add_time?.split('.')[0]}</td>
                            <td><Link
                                to={`/min-result-entry/${row.appt_id}/${row.itest_id.split(',')[subIndex].trim()}`}
                                className="btn btn-success">View</Link></td>

                        </tr>
                    ))}
                    </tbody>
                )}
            </table>

        </section>
    )
}
export default Minview;
